import { GuidObjectType } from '../models';

export interface CustomFieldReplacement {
    value: string;
    //isInherited: boolean; // don't take into account, is not true
    ownerName: string;
    ownerType: GuidObjectType;
}

export class CustomReplacementDictionary {
    [key: string]: CustomFieldReplacement
}